<template>
  <div id="add-admin-modal">

    <memlist-modal ref="modal">

      <m-row>
        <m-col lg="12">
          <h3>Skapa administratörer för {{ company_name }}</h3>
        </m-col>
      </m-row>
      <m-row>
        <m-col lg="12">
          <p>Här kan du lägga till alla administratörer som ska ha tillgång till föreningen. Ifall du behöver fler än 1 kan du klicka på "Lägg till ytterligare administratör".</p>
          <p>Om du ej vill lägga till administatör nu kan du stänga denna popup.</p>
        </m-col>
      </m-row>

      <div v-for="(user, i) in users" v-bind:key="i">
        <AddAdminRow
          class="mt-4"
          :index="i"
          @changed="row_changed"
        />

      </div>
      

      <m-row>
        <m-col lg="12">
          <div class="mt-4 ml-4 text-right">
            <a @click.prevent="add_admin" href="" style="font-size: 18px; ">+ Lägg till ytterligare administratör</a>
          </div>
          
        </m-col>
      </m-row>

      <m-row>
        <m-col lg="12">
          <RightSaveButton
            class="mt-4"
            ref="save-button"
            :text="$t('COMMON.SAVE')"
            @click="save_users()"
          />
        </m-col>
      </m-row>
      
    </memlist-modal>
    
  </div>
</template>


<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import AddAdminRow from './AddAdminRow.vue';

export default {
  name: 'AddAdminModal',
  components: {
    RightSaveButton,
    AddAdminRow,
  },
  mixins: [ toasts ],
  props: ['company_id','company_name'],
  emits: ['saved', 'change'],
  computed: {

    ...mapGetters(['currentPeriodId', 'currentCompanyId', 'companies']),
    
  },
  mounted() {

  },
  data() {
    return {
      users: [{}],
    };
  },
  watch: {

    company_id(newValue, oldValue) {
      
    },
    

  },
  methods: {
    add_admin() {
      this.users.push({});
    },
    row_changed(index, data) {
      this.users[index] = data;
    },
    show() {
      this.$refs['modal'].show();
    },
    hide() {
      this.$refs['modal'].hide();
    },
    async save_users() {
      const res = await axios.post(`/access/users/quick`, { users: this.users, company_id: this.company_id });
      this.$refs['save-button'].stop();
      
      if (res.status === 201) {
        this.hide();
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_CREATE'));
      }
    },

  }
};
</script>
